import { PANELS } from '../../../tool/dynamicReport/helper/portfolioInsight/finance'
import { DISPLAY_TYPES } from '../constants'
import {
  exportAssetManagementEfficiency,
  exportAssetQuality,
  exportBusinessGrowth,
  exportCapitalAdequacy,
  exportCapitalEarningLeverage,
  exportEarningsQuality,
  exportFundingLiquidity,
  exportLiquiditySolvencyAndCoverage,
  exportProfitability,
  exportSecuritiesBusinessPosition,
  postAssetManagementEfficiency,
  postAssetQuality,
  postBusinessGrowth,
  postBusinessPosition,
  postCapitalAdequacy,
  postCapitalEarningLeverage,
  postEarningsQuality,
  postFundingLiquidity,
  postLiquiditySolvencyAndCoverage,
  postProfitability,
} from '../store/thunk'

const {
  CORPORATE,
  BANK,
  SECURITIES,
  LIFE_INSURANCE,
  NON_LIFE_INSURANCE,
  NON_BANK,
} = DISPLAY_TYPES

const {
  LIQUIDITY_SOLVENCY_AND_COVERAGE,
  ASSET_MANAGEMENT_EFFICIENCY,
  PROFITABILITY,
  BUSINESS_GROWTH_CORP,
  CAPITAL_ADEQUACY,
  ASSET_QUALITY,
  EARNINGS_QUALITY,
  FUNDING_AND_LIQUIDITY_BANK,
  BUSINESS_GROWTH_BANK,
  BUSINESS_POSITION,
  CAPITAL_EARNING_AND_LEVERAGE,
  FUNDING_AND_LIQUIDITY_SEC,
} = PANELS

export const DYNAMIC_CONTAINER = {
  [CORPORATE]: [
    {
      label: 'LIQUIDITY_SOLVENCY',
      downloadFunc: exportLiquiditySolvencyAndCoverage,
      callApi: postLiquiditySolvencyAndCoverage,
      className: 'box1',
      dynamicKey: LIQUIDITY_SOLVENCY_AND_COVERAGE,
      companyType: 'CT',
      ratiosSelected: [
        'RT0020',
        'RT0019',
        'RT0018',
        'RT0033',
        'RT0027',
        'RT0037',
        'RT0047',
        'RT0044',
        'RT0046',
        'RT0045',
      ],
    },
    {
      label: 'ASSET_MANAGEMENT',
      downloadFunc: exportAssetManagementEfficiency,
      callApi: postAssetManagementEfficiency,
      className: 'box2',
      dynamicKey: ASSET_MANAGEMENT_EFFICIENCY,
      companyType: 'CT',
      ratiosSelected: [
        'RT0009',
        'RT0011',
        'RT0013',
        'RT0015',
        'RT0003',
        'RT0006',
      ],
    },
    {
      label: 'PROFITABILITY',
      downloadFunc: exportProfitability,
      callApi: postProfitability,
      className: 'box3',
      dynamicKey: PROFITABILITY,
      companyType: 'CT',
      ratiosSelected: [
        'RT0050',
        'RT0348',
        'RT0054',
        'RT0052',
        'RT0051',
        'RT0060',
        'RT0059',
      ],
    },
    {
      label: 'BUSINESS_GROWTH',
      downloadFunc: exportBusinessGrowth,
      callApi: postBusinessGrowth,
      className: 'box4',
      dynamicKey: BUSINESS_GROWTH_CORP,
      companyType: 'CT',
      ratiosSelected: [
        'RT0156',
        'RT0161',
        'RT0159',
        'RT0387',
        'RT0172',
        'RT0174',
      ],
    },
  ],
  [BANK]: [
    {
      label: 'CAPITAL_ADEQUACY_PANEL',
      downloadFunc: exportCapitalAdequacy,
      callApi: postCapitalAdequacy,
      className: 'box1',
      dynamicKey: CAPITAL_ADEQUACY,
      companyType: 'NH',
      ratiosSelected: ['RT0249', 'NB219', 'RT0248'],
    },
    {
      label: 'ASSET_QUALITY',
      downloadFunc: exportAssetQuality,
      callApi: postAssetQuality,
      className: 'box2',
      dynamicKey: ASSET_QUALITY,
      companyType: 'NH',
      ratiosSelected: ['RT0266', 'RT0237', 'RT0238', 'RT0236'],
    },
    {
      label: 'EARING_QUALITY',
      downloadFunc: exportEarningsQuality,
      callApi: postEarningsQuality,
      className: 'box3',
      dynamicKey: EARNINGS_QUALITY,
      companyType: 'NH',
      ratiosSelected: ['RT0285', 'RT0252', 'RT0060', 'RT0059'],
    },
    {
      label: 'FUNDING_LIQUIDITY',
      downloadFunc: exportFundingLiquidity,
      callApi: postFundingLiquidity,
      className: 'box4',
      dynamicKey: FUNDING_AND_LIQUIDITY_BANK,
      companyType: 'NH',
      ratiosSelected: ['RT0277', 'LATL', 'RT0287'],
    },
    {
      label: 'BUSINESS_GROWTH',
      downloadFunc: exportBusinessGrowth,
      callApi: postBusinessGrowth,
      className: 'box5',
      dynamicKey: BUSINESS_GROWTH_BANK,
      companyType: 'NH',
      ratiosSelected: ['RT0173', 'RT0172', 'RT0296', 'RT0161'],
    },
  ],
  [SECURITIES]: [
    {
      label: 'BUSINESS_POSITION',
      downloadFunc: exportSecuritiesBusinessPosition,
      callApi: postBusinessPosition,
      className: 'box1',
      dynamicKey: BUSINESS_POSITION,
      companyType: 'CK',
      ratiosSelected: ['SABBMS', 'OSBMS'],
    },
    {
      label: 'CAPITAL_EARNING',
      downloadFunc: exportCapitalEarningLeverage,
      callApi: postCapitalEarningLeverage,
      className: 'box2',
      dynamicKey: CAPITAL_EARNING_AND_LEVERAGE,
      companyType: 'CK',
      ratiosSelected: ['RT0060', 'RT0059', 'RT0034', 'CIR', 'LTE'],
    },
    {
      label: 'FUNDING_LIQUIDITY',
      downloadFunc: exportFundingLiquidity,
      callApi: postFundingLiquidity,
      className: 'box3',
      dynamicKey: FUNDING_AND_LIQUIDITY_SEC,
      companyType: 'CK',
      ratiosSelected: ['STF', 'LTF', 'LTFLA', 'LASTF'],
    },
  ],
  [LIFE_INSURANCE]: [
    {
      label: 'LIQUIDITY_SOLVENCY',
      downloadFunc: exportLiquiditySolvencyAndCoverage,
      callApi: postLiquiditySolvencyAndCoverage,
      className: 'box1',
      dynamicKey: LIQUIDITY_SOLVENCY_AND_COVERAGE,
      companyType: 'BHNT',
      ratiosSelected: ['RT0020', 'RT0019', 'RT0018', 'RT0034'],
    },
    {
      label: 'PROFITABILITY',
      downloadFunc: exportProfitability,
      callApi: postProfitability,
      className: 'box2',
      dynamicKey: PROFITABILITY,
      companyType: 'BHNT',
      ratiosSelected: [
        'RT2002',
        'RT2004',
        'RT2003',
        'RT2017',
        'RT2018',
        'RT0416',
      ],
    },
    {
      label: 'BUSINESS_GROWTH',
      downloadFunc: exportBusinessGrowth,
      callApi: postBusinessGrowth,
      className: 'box3',
      dynamicKey: BUSINESS_GROWTH_CORP,
      companyType: 'BHNT',
      ratiosSelected: ['IPG', 'RT0418', 'RT2008', 'CCG', 'RT0173', 'RT0172'],
    },
  ],
  [NON_LIFE_INSURANCE]: [
    {
      label: 'LIQUIDITY_SOLVENCY',
      downloadFunc: exportLiquiditySolvencyAndCoverage,
      callApi: postLiquiditySolvencyAndCoverage,
      className: 'box1',
      dynamicKey: LIQUIDITY_SOLVENCY_AND_COVERAGE,
      companyType: 'BHPNT',
      ratiosSelected: ['RT0020', 'RT0019', 'RT0018', 'RT0034'],
    },
    {
      label: 'PROFITABILITY',
      downloadFunc: exportProfitability,
      callApi: postProfitability,
      className: 'box2',
      dynamicKey: PROFITABILITY,
      companyType: 'BHPNT',
      ratiosSelected: [
        'RT2002',
        'RT2004',
        'RT2003',
        'RT2017',
        'RT2018',
        'RT0416',
      ],
    },
    {
      label: 'BUSINESS_GROWTH',
      downloadFunc: exportBusinessGrowth,
      callApi: postBusinessGrowth,
      className: 'box3',
      dynamicKey: BUSINESS_GROWTH_CORP,
      companyType: 'BHPNT',
      ratiosSelected: ['IPG', 'RT0418', 'RT2008', 'CCG', 'RT0173', 'RT0172'],
    },
  ],
  [NON_BANK]: [
    {
      label: 'LIQUIDITY_SOLVENCY',
      downloadFunc: exportLiquiditySolvencyAndCoverage,
      callApi: postLiquiditySolvencyAndCoverage,
      className: 'box1',
      dynamicKey: LIQUIDITY_SOLVENCY_AND_COVERAGE,
      companyType: 'FIO',
      ratiosSelected: ['RT0411', 'RT0413', 'RT0034', 'RT0027', 'RT0412'],
    },
    {
      label: 'PROFITABILITY',
      downloadFunc: exportProfitability,
      callApi: postProfitability,
      className: 'box2',
      dynamicKey: PROFITABILITY,
      companyType: 'FIO',
      ratiosSelected: ['RT2002', 'RT2004', 'RT2003'],
    },
    {
      label: 'BUSINESS_GROWTH',
      downloadFunc: exportBusinessGrowth,
      callApi: postBusinessGrowth,
      className: 'box3',
      dynamicKey: BUSINESS_GROWTH_CORP,
      companyType: 'FIO',
      ratiosSelected: ['RT2008', 'CCG', 'RT0156', 'RT0173', 'RT0172'],
    },
    {
      label: 'ASSET_QUALITY',
      downloadFunc: exportAssetQuality,
      callApi: postAssetQuality,
      className: 'box4',
      dynamicKey: ASSET_QUALITY,
      companyType: 'FIO',
      ratiosSelected: ['RT0410', 'RT0414', 'RT0415'],
    },
  ],
}

export const SCROLL_OPTIONS = {
  [CORPORATE]: [
    {
      scrollPosition: 'box1',
      rowId: 'RT0020',
      keyTypePrefix: 'postLiquiditySolvencyAndCoverage',
    },
    {
      scrollPosition: 'box1',
      rowId: 'RT0033',
      keyTypePrefix: 'postLiquiditySolvencyAndCoverage',
    },
    {
      scrollPosition: 'box3',
      rowId: 'RT0059',
      keyTypePrefix: 'postProfitability',
    },
    {
      scrollPosition: 'box4',
      rowId: 'RT0156',
      keyTypePrefix: 'postBusinessGrowth',
    },
    {
      scrollPosition: 'box2',
      rowId: 'RT0015',
      keyTypePrefix: 'postAssetManagementEfficiency',
    },
  ],
  [BANK]: [
    {
      scrollPosition: 'box1',
      rowId: 'NB219',
      keyTypePrefix: 'postCapitalAdequacy',
    },
    {
      scrollPosition: 'box3',
      rowId: 'RT0285',
      keyTypePrefix: 'postEarningsQuality',
    },
    {
      scrollPosition: 'box2',
      rowId: 'RT0236',
      keyTypePrefix: 'postAssetQuality',
    },
    {
      scrollPosition: 'box3',
      rowId: 'RT0059',
      keyTypePrefix: 'postEarningsQuality',
    },
    {
      scrollPosition: 'box4',
      rowId: 'RT0277',
      keyTypePrefix: 'postFundingLiquidity',
    },
  ],
  [SECURITIES]: [
    {
      scrollPosition: 'box1',
      rowId: 'SABBMS',
      keyTypePrefix: 'postBusinessPosition',
    },
    {
      scrollPosition: 'box2',
      rowId: 'RT0060',
      keyTypePrefix: 'postCapitalEarningLeverage',
    },
    {
      scrollPosition: 'box2',
      rowId: 'LTE',
      keyTypePrefix: 'postCapitalEarningLeverage',
    },
    {
      scrollPosition: 'box2',
      rowId: 'CIR',
      keyTypePrefix: 'postCapitalEarningLeverage',
    },
    {
      scrollPosition: 'box2',
      rowId: 'RT0034',
      keyTypePrefix: 'postCapitalEarningLeverage',
    },
  ],
  [LIFE_INSURANCE]: [
    {
      scrollPosition: 'box2',
      rowId: 'RT2003',
      keyTypePrefix: 'postProfitability',
    },
    {
      scrollPosition: 'box2',
      rowId: 'RT2017',
      keyTypePrefix: 'postProfitability',
    },
    {
      scrollPosition: 'box2',
      rowId: 'RT0416',
      keyTypePrefix: 'postProfitability',
    },
    {
      scrollPosition: 'box3',
      rowId: 'IPG',
      keyTypePrefix: 'postBusinessGrowth',
    },
  ],
  [NON_LIFE_INSURANCE]: [
    {
      scrollPosition: 'box2',
      rowId: 'RT2003',
      keyTypePrefix: 'postProfitability',
    },
    {
      scrollPosition: 'box2',
      rowId: 'RT2017',
      keyTypePrefix: 'postProfitability',
    },
    {
      scrollPosition: 'box2',
      rowId: 'RT0416',
      keyTypePrefix: 'postProfitability',
    },
    {
      scrollPosition: 'box3',
      rowId: 'IPG',
      keyTypePrefix: 'postBusinessGrowth',
    },
  ],
  [NON_BANK]: [
    {
      scrollPosition: 'box1',
      rowId: 'RT0411',
      keyTypePrefix: 'postLiquiditySolvencyAndCoverage',
    },
    {
      scrollPosition: 'box1',
      rowId: 'RT0413',
      keyTypePrefix: 'postLiquiditySolvencyAndCoverage',
    },
    {
      scrollPosition: 'box2',
      rowId: 'RT2003',
      keyTypePrefix: 'postProfitability',
    },
    {
      scrollPosition: 'box3',
      rowId: 'RT0156',
      keyTypePrefix: 'postBusinessGrowth',
    },
    {
      scrollPosition: 'box4',
      rowId: 'RT0410',
      keyTypePrefix: 'postAssetQuality',
    },
    {
      scrollPosition: 'box4',
      rowId: 'RT0414',
      keyTypePrefix: 'postAssetQuality',
    },
  ],
}

export const HIGH_LIGHT_RATIO = {
  [CORPORATE]: ['RT0020', 'RT0033', 'RT0059', 'RT0156', 'RT0015'],
  [BANK]: ['NB219', 'RT0285', 'RT0236', 'RT0059', 'RT0277'],
  [SECURITIES]: ['SABBMS', 'RT0060', 'LTTE', 'CTIR', 'RT0034'],
  [LIFE_INSURANCE]: ['RT2003', 'RT2017', 'RT0416', 'IPG'],
  [NON_LIFE_INSURANCE]: ['RT2003', 'RT2017', 'RT0416', 'IPG'],
  [NON_BANK]: ['RT0411', 'RT0413', 'RT2003', 'RT0156', 'RT0410', 'RT0414'],
}

export const PANEL_FINANCE_BY_DYNAMIC_KEY = Object.values(DYNAMIC_CONTAINER)
  .flat()
  .reduce((prev, cur) => {
    return {
      ...prev,
      [cur.dynamicKey]: cur,
    }
  }, {})
